import React from "react";
import {
  CongratIcon,
  Container,
  Header,
  IconContainer,
  Detail,
  ClaimIcon,
  PromptIcon,
  RequestIcon,
  ComplainIcon,
} from "./style";
type IconType = "congrats" | "claim" | "request" | "prompt" | "complain";
interface ICaseCardProps {
  title: string;
  icon: IconType;
  detail: string;
  color: string;
  type: number;
  handleSelect: (type: number, title: string, color: string) => void;
}
const CaseCard = ({
  icon,
  title,
  detail,
  color,
  handleSelect,
  type,
}: ICaseCardProps) => {
  return (
    <Container
      onClick={() => {
        handleSelect(type, title, color);
      }}
    >
      <Header bg={color}>{title}</Header>
      <IconContainer>
        <Icon icon={icon} />
      </IconContainer>
      <Detail>{detail}</Detail>
    </Container>
  );
};

const Icon = ({ icon }: { icon: IconType }) => {
  switch (icon) {
    case "congrats":
      return <CongratIcon />;
    case "claim":
      return <ClaimIcon />;
    case "prompt":
      return <PromptIcon />;
    case "request":
      return <RequestIcon />;
    case "complain":
      return <ComplainIcon />;
    default:
      return null;
  }
};

export default CaseCard;
